<template>
  <div class="giftPage">
    <header>
      <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="16"
          viewBox="0 0 20 16"
          @click="goBack()"
        >
          <g fill="#000" fill-rule="evenodd">
            <path
              d="M18.2 6.72c.591 0 1.07.501 1.07 1.12 0 .619-.479 1.12-1.07 1.12H1.07C.48 8.96 0 8.459 0 7.84c0-.619.48-1.12 1.07-1.12H18.2z"
            />
            <path
              d="M2.585 7.84l5.666 5.928a1.157 1.157 0 0 1 0 1.584 1.038 1.038 0 0 1-1.514 0L.314 8.632a1.157 1.157 0 0 1 0-1.584L6.737.328a1.038 1.038 0 0 1 1.514 0 1.157 1.157 0 0 1 0 1.584L2.585 7.84z"
            />
          </g>
        </svg>
      <h3>{{$t('giftWonbyYou')}}</h3>
    </header>
    <section class="page-content">
        <div class="filter_product_list" v-if="giftList.length > 0">
          <div
            ref="container"
            class="filter_card"
             :class="{'new-item-card': isTileView === 'LIST_VIEW'}"
            v-for="(product,index) in giftList"
            :key="index"
            
          >
          <img src="../assets/images/icons/verified-icon.png" alt="loader" class="mVerified-Icon" v-if="product.sellerLiteDTO.isApproved"/>
       <p class="home-delivery-text" v-if="product.sellerLiteDTO.sellerShopSettingDTO && product.sellerLiteDTO.sellerShopSettingDTO.homeDeliveryAvailable &&isTileView === 'LIST_VIEW'">FREE HOME DELIVERY</p>
            <div class="img_wrapper spinner_wrapper" v-lazyload v-if="product.displayImage" @click="goToProductDetail(product.sellerItemRelationshipId)">
              <ImageSpinner class="image_spinner" />
              <img :data-url="product.displayImage" alt />
            </div>
            <div class="product_detail">
              <p class="product-name">{{product.productName}}</p>
              <p class="bought rating" style="display:flex;" v-if="parseFloat(product.averageRating) > 0">
                <star-rating
                  :read-only="true"
                  :increment="0.01"
                  :starSize="10"
                  active-color="#138808"
                  :rating="Number(product.averageRating)"
                  :show-rating="false"
                ></star-rating>
                <span style="padding-left: 4px;"> ({{product.ratingNum}})</span>
              </p>
              <p class="bought rating" style="display:flex;" v-else-if="!product.averageRating && $store.state.isViewType === 'GRID_VIEW'">
          No ratings yet
          </p>
              <div class="my_price_section flx">
                <span class="my_price" v-if="product.sellingPrice">
              <span class="rupee-font">₹​</span>{{ product.sellingPrice }}
              <span class="sp-badge" v-if="parseFloat(product.mrp) > parseFloat(product.sellingPriceWithoutDiscount)  && $store.state.isViewType === 'LIST_VIEW'">Your Price</span>
              </span>
            <span class="selling_price" v-if="product.sellingPriceWithoutDiscount"
              ><span class="rupee-font">₹​</span>​{{ product.sellingPriceWithoutDiscount }}</span
            >
            <span class="selling_price" v-if="parseFloat(product.mrp) > parseFloat(product.sellingPriceWithoutDiscount) && product.mrp"
              ><span class="rupee-font">₹​</span>​{{ product.mrp }}</span
            >
              </div>
              <label class="price-less-tag" v-if="parseFloat(product.mrp) > parseFloat(product.sellingPrice)">{{$t('lessWithXPrice',{lessAmount:Math.round(parseFloat(product.mrp)-parseFloat(product.sellingPrice))})}} </label>
              
              <p class="bought" style="color:black" @click="viewShop(product.sellerLiteDTO.shopId)">
                {{$t('shop')}} -
                <span style="color:green">{{product.sellerLiteDTO.storeName}}</span>
                <!-- {{$t('peopleHaveBrought')}} -->
            </p>
            <p class="home-delivery-text" v-if="product.sellerLiteDTO.sellerShopSettingDTO && product.sellerLiteDTO.sellerShopSettingDTO.homeDeliveryAvailable && isTileView === 'GRID_VIEW'">FREE HOME DELIVERY</p>
            <p class="time">
                <Timer
                @StopTime="timerStop"
                :timing="getTime(product.dealEndTimeMillis,index)"
                :Index="index"
                :GroupID="product.groupId"
                />
            </p>
            <p v-if="product.gmallProductId" @click="goToProductDetail(product.sellerItemRelationshipId)">
              <ListQuantity :dataQuantity="product" @updateCartCount="getUpdatedCartCount"  />
              </p>
              <p v-else  >
                <ListQuantity :dataQuantity="product" @updateCartCount="getUpdatedCartCount"  />
              </p>
            </div>
          </div>
        </div>
      <NoDataFound v-if="isDataLength" />
    </section>
    <div class="loader" v-if="loading">
      <img src="../assets/images/loader.gif" alt="loader" />
    </div>
  </div>
</template>

<script>
import ApiCaller from "../utils/apicaller";
import constant from "../utils/constant";
import Timer from "../components/Common/TimeCount";
import NoDataFound from "../components/Common/NoDataFound"
import StarRating from "vue-star-rating";
import ListQuantity from "./ListQuantity";
import ImageSpinner from "../components/Common/ImageSpinner";
export default {
  name: "GiftList",
   components: {
    Timer,
    NoDataFound,
    StarRating,
    ListQuantity,
    ImageSpinner
  },
  data() {
    return {
      groupExpireTime: "",
      groupId: null,
      giftList: [],
      isDataLength: false,
      loading: false,
      isTileView: ''
    };
  },
  methods: {
      goBack() {
      if (this.$cookie.get("version-code") > 57) {
        if (window.history.length == 1) {
          try {
            JSBridgePlugin.gotToHome();
          } catch (err) {
            console.log(err);
          }
        } else {
          this.$router.go(-1);
        }
      } else {
        this.$router.go(-1);
      }
    },
    getUpdatedCartCount(){
      this.$store.commit(types.UPDATE_CART_SIZE, Math.round(parseInt(this.cartSize) + 1));
    },
    goToProductDetail(productId){
      this.$router.push("/detail/" + productId + "?source=SCRATCH");
    },
    timerStop(obj) {
      if (this.giftList.length > 0) {
        this.giftList[obj.index].status = false;
      }
    },
    getTime(value, index) {
      let milliseconds = Number(value) / 1000;
      return milliseconds;
    },
    getGiftList() {
      this.loading = true;
      ApiCaller(
        constant.LOCAL_SHOP_URL,
        "offer-product-listing/0",
        "get"
      ).then(data => {
         this.loading = false;
        if(this.$store.state.isViewType){
            this.isTileView = this.$store.state.isViewType
        }else{
        ApiCaller(constant.APP_SETTING_SERVICE_URL, "get-aap-settings" , "get")
            .then(data => {
                this.$store.commit('VIEW_TYPE', data.data[0].designStyle);
                this.isTileView = data.data[0].designStyle
                console.log(this.isTileView, this.$store.state.isViewType)
            })
            .catch(err => {
                console.log(err);
            });
        }
    
         this.giftList = data.data.productListingDTOs;
         if(data.data.hasOwnProperty("productListingDTOs")){
            this.isDataLength = false;
         }else{
           this.isDataLength = true
         }
        
      }).catch(err => {
          this.loading = false;
        });
    },

  },
  mounted() {
    this.getGiftList()
  }
};
</script>
<style lang="scss" scoped>
@mixin flex-prop {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  flex-shrink: 0;
}
.giftPage {
  width: 100%;
  background-color: #f4f6f8;
  padding: 54px 0;
  min-height: 100vh;
  header {
    width: 100%;
    position: fixed;
    top: 0;
    z-index: 10;
    @include flex-prop();
    padding: 15px;
    background: #fff;
    h3{
      padding-left: 15px;
    }
  }
}
</style>
